export default __webpack_public_path__ + "static/media/money12.1b897436.svg";